import { RegistrationFailureModel } from '../models/registration_failure_model';
import { RegistrationAlertsServant } from '../servants/registration_alerts_servant';
import { ITermCoursesDatasource } from '../../term_courses/datasources/term_courses_datasource';
import { IQueryMediator, ICommand } from 'core-ts-types';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { IDefineCommand } from 'core-ts-types';
import { ScheduledSectionStatus } from '../types/scheduled_section_status_enum';
import { IRegisterSectionsDatasource } from '../datasources/register_sections_datasource';
import { UpdateCalendarSectionTimesCommand } from '../../calendar/commands/update_calendar_section_times_command';
import { RemoveSectionSelectionCommand } from '../../../components/section_selections/commands/remove_section_selection_command';
import { ScheduledSectionRequestStateCommand } from '../../../request_state/commands/scheduled_section_request_state_command';

angular
  .module('capability-ng-scheduler')
  .service(
    'unscheduleSectionCommand',
    function unscheduleSectionCommand(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      SectionStatusCollectionBuilder: any,
      ngSectionsDatasource: ISectionsDatasource,
      QueryMediator: IQueryMediator,
      ngTermCoursesDatasource: ITermCoursesDatasource,
      registrationActivityCommand: ICommand,
      ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
      ngRegistrationAlertsServant: RegistrationAlertsServant,
      ngRegistrationFailureModel: RegistrationFailureModel,
      updateCalendarSectionTimesCommand: UpdateCalendarSectionTimesCommand,
      removeSectionSelectionCommand: RemoveSectionSelectionCommand,
      scheduledSectionRequestStateCommand: ScheduledSectionRequestStateCommand,
      log: any
    ) {
      'use strict';

      return defineCommandORM('unscheduleSectionCommand', (deferred, termId, sectionId) => {
        scheduledSectionRequestStateCommand([sectionId], true);
        $http
          .delete(`reg/course_schedule/term/${termId}/section/${sectionId}/`)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            const sectionToUnSchedule = ngSectionsDatasource.get(sectionId);
            if (sectionToUnSchedule) {
              sectionToUnSchedule.status = ScheduledSectionStatus.UNSCHEDULED;
              ngSectionsDatasource.put(sectionToUnSchedule);
              ngRegistrationFailureModel.del(sectionToUnSchedule.id);
            }
            const removeSectionFromReg = ngRegisterSectionsDatasource.get(sectionId);
            if (removeSectionFromReg) {
              ngRegisterSectionsDatasource.del(sectionId);
              removeSectionSelectionCommand(sectionId);
            }
            return updateCalendarSectionTimesCommand();
          })
          .then(() => {
            scheduledSectionRequestStateCommand([sectionId], false);
            deferred.resolve();
            registrationActivityCommand(termId);
          })
          .catch(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            scheduledSectionRequestStateCommand([sectionId], false);
            ngRegistrationAlertsServant.showUnScheduleFailAlert(sectionId);
            deferred.reject(data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/commands/unschedule_section_command.ts